import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class AudioService {
	public play(url: any): void {
		//Instantiate HTMLAudio and play the url. Will be garbage collected automatically.
		let audio = new Audio();
		audio.src = url;
		audio.load();
		audio.play();
	}

	public playBlob(blob: Blob) {
		this.play(window.URL.createObjectURL(blob));
	}

	public async playNodeBuffer(buffer: any): Promise<any> {
		function toArrayBuffer(buf: any) {
			const ab = new ArrayBuffer(buf.length);
			const view = new Uint8Array(ab);
			for (let i = 0; i < buf.length; ++i) {
				view[i] = buf[i];
			}
			return ab;
		}

		const context = new AudioContext();
		const source = context.createBufferSource();
		const audioBuffer = await context.decodeAudioData(toArrayBuffer(buffer));
		source.buffer = audioBuffer;
		source.connect(context.destination);
		return source.start();
	}
}
